/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Component imports
import { Form, InputNumber } from 'antd';
import EntryPointSelect from '../../../Forms/Fields/EntryPointSelect';

// Misc imports
import { useBotLanguage } from '../../../../utils/hooks/useBotLanguage';
import { ACTIVITY_TYPES } from '../../../../constants/main';

const UserFeedbackNodeForm = ({ form, selectedElement }) => {
  const { t } = useTranslation();
  const { isEditingPrimaryLanguage } = useBotLanguage();

  return (
    <Fragment>
      <Form.Item
        label={t('Feedback flow to redirect to')}
        name={['data', 'jumpTo']}
        rules={[{ required: true, message: t('Flow cannot be blank.') }]}
      >
        <EntryPointSelect
          size="large"
          activityTypesToDisplay={[ACTIVITY_TYPES.USER_FEEDBACK]}
          disabled={!isEditingPrimaryLanguage}
        />
      </Form.Item>

      <Form.Item
        label={t('Probability to ask for feedback')}
        name={['data', 'jumpProbabilityLocal']}
        rules={[{ required: true, message: t('Please enter a probability.') }]}
        initialValue={(Number(selectedElement.data.jumpProbability) || 1) * 100}
      >
        <InputNumber
          size="large"
          min={0}
          max={100}
          addonAfter="%"
          onChange={(value) => form.setFieldValue(['data', 'jumpProbability'], value / 100)}
          disabled={!isEditingPrimaryLanguage}
        />
      </Form.Item>

      <Form.Item
        name={['data', 'jumpProbability']}
        hidden
      >
        <InputNumber />
      </Form.Item>
    </Fragment>
  );
};

UserFeedbackNodeForm.propTypes = {
  form: PropTypes.object.isRequired,
  selectedElement: PropTypes.object.isRequired
};

export default UserFeedbackNodeForm;
